import { useCallback } from 'react'
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react"
import { useRouter } from "next/navigation"

const BlogHeader = ({ onMobileMenuToggle }) => {
  const router = useRouter();

  const handleBackClick = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <header className="w-full sticky top-0 z-50 bg-white border-b border-[#e3e3e3] flex justify-between items-center">
      <div className="w-full flex items-center justify-between mr-5">
        <Button
          variant="ghost"
          size="lg"
          onClick={handleBackClick}
          className="h-16 w-16"
          aria-label="Go back"
        >
          <ArrowLeft className="h-10 w-10" />
        </Button>
        {/* Hamburger on mobile */}
        <button
          className="block md:hidden p-3"
          onClick={onMobileMenuToggle}
          aria-label="Open menu"
        >
          <div className="relative w-6 h-6">
            <span className="absolute left-0 top-1 w-6 h-0.5 bg-current rounded-full" />
            <span className="absolute left-0 top-3 w-6 h-0.5 bg-current rounded-full" />
            <span className="absolute left-0 top-5 w-6 h-0.5 bg-current rounded-full" />
          </div>
        </button>
      </div>
    </header>
  )
}

export default BlogHeader;
